import { render } from "./CreateAddress.vue?vue&type=template&id=28fe57cf"
import script from "./CreateAddress.vue?vue&type=script&lang=js"
export * from "./CreateAddress.vue?vue&type=script&lang=js"

import "./CreateAddress.vue?vue&type=style&index=0&id=28fe57cf&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__